import { FC } from 'react'
import { FeedMedia } from 'shared/src/api/types'

import { RodeoButton } from '../RodeoButton'

interface Props {
  media: FeedMedia
  onClick: () => void
  active: boolean
  className?: string
}

export const ProductsButton: FC<Props> = ({
  media: { products },
  onClick,
  active,
  className,
}) => (
  <RodeoButton
    number={products.length}
    onClick={onClick}
    active={active}
    className={className}
  />
)
